import type { ReactNode } from 'react'

export interface KpiStripProps {
  children: ReactNode
}

/** Evenly distributed KPI row; min-w lets cards wrap on displays under ~1400px. */
export function KpiStrip({ children }: KpiStripProps) {
  return <div className="flex flex-wrap gap-3 [&>*]:min-w-[168px] [&>*]:flex-1">{children}</div>
}
